export default __webpack_public_path__ + "static/media/avalon.7cc52c30.svg";